import { render } from "./Popup.vue?vue&type=template&id=51ed29b0"
import script from "./Popup.vue?vue&type=script&lang=js"
export * from "./Popup.vue?vue&type=script&lang=js"
script.render = render

export default script